/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { fireErrorAnalytics } from '@jira/platform__error-reporting/src/fireErrorAnalytics.tsx';
import { userPreferenceAPI } from '@jira/platform__services-user-preferences/src/utils/index.tsx';
import {
	JIRA_EDITION_AWARENESS_FOR_STANDARD_TO_PREMIUM_PACKAGE_NAME,
	JIRA_EDITION_AWARENESS_FOR_STANDARD_TO_PREMIUM_PILL_DISMISSED,
} from './types.tsx';

export const setEditionAwarenessPillDismissed = async (value: boolean): Promise<void> => {
	try {
		await userPreferenceAPI.set(
			JIRA_EDITION_AWARENESS_FOR_STANDARD_TO_PREMIUM_PILL_DISMISSED,
			value,
		);
		// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (err: any) {
		fireErrorAnalytics({
			error: err,
			meta: {
				id: 'setEditionAwarenessPillDismissed',
				packageName: JIRA_EDITION_AWARENESS_FOR_STANDARD_TO_PREMIUM_PACKAGE_NAME,
			},
		});
	}
};

export const fetchEditionAwarenessPillDismissed = async (): Promise<boolean | null | undefined> => {
	try {
		return await userPreferenceAPI.get(
			JIRA_EDITION_AWARENESS_FOR_STANDARD_TO_PREMIUM_PILL_DISMISSED,
		);
		// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (err: any) {
		// 404 is acceptable as it means user hasn't dismissed it yet
		if (err.statusCode === 404) return null;

		fireErrorAnalytics({
			error: err,
			meta: {
				id: 'fetchEditionAwarenessPillDismissed',
				packageName: JIRA_EDITION_AWARENESS_FOR_STANDARD_TO_PREMIUM_PACKAGE_NAME,
			},
		});

		return undefined;
	}
};
